import ItemsDetailsMobileWrapper from 'components/ItemsDetailsMobileWrapper'
import ItemHeader from 'containers/ManageAccess/ItemHeader'
import { useIsSmallScreen, useQuery } from 'packages/core'
import { Loader } from 'packages/eid-ui'
import {
    useCheckMailboxAccessByAssignmentId,
    useMailboxManageAccess,
    useTargetPerson,
} from 'hooks'
import MailboxDetails from './MailboxDetails'
import { ManageAccessDrawer } from 'components/Drawer/ManageAccessDrawer'

const MailboxesDrawer = ({ attributes, toggleDrawer, ...rest }) => {
    const isSmallScreen = useIsSmallScreen()
    const headerAttribute = attributes.find((x) => x.isHeader)

    const [targetPerson] = useTargetPerson()

    const query = useQuery()
    const id = query.get('selected')
    const assignmentId = query.get('assignmentId')

    const { data: assignmentStatus } = useCheckMailboxAccessByAssignmentId(
        assignmentId,
        targetPerson.id,
    )

    const { data: mailbox } = useMailboxManageAccess(
        assignmentId ? assignmentId : id,
        assignmentId ? true : false,
        targetPerson?.id,
    )

    let item
    if (mailbox && assignmentStatus) {
        item = {
            resource: mailbox,
            assignment: assignmentStatus,
        }
    }

    const itemDetails = <MailboxDetails item={item} {...rest} />

    return isSmallScreen ? (
        <ItemsDetailsMobileWrapper toggleDrawer={toggleDrawer}>
            <ItemHeader title={item?.resource?.[headerAttribute.name]} />
            {!item && <Loader />}
            {item && itemDetails}
        </ItemsDetailsMobileWrapper>
    ) : (
        <ManageAccessDrawer
            id={id}
            toggleDrawer={toggleDrawer}
            item={item}
            itemDetails={itemDetails}
            headerAttribute={headerAttribute}
        />
    )
}

export default MailboxesDrawer
